module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body-components",
    staticClass: "body-components"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.resizeBody
    }
  }), _c('div', {
    ref: "articleBody",
    staticClass: "article-body"
  }, [_vm._l((_vm.contentList), function(item, index) {
    return [(item.type === 'text') ? _c('body-text', {
      ref: _vm.setElementRef('text', index),
      refInFor: true,
      attrs: {
        "item": item,
        "node": _vm.node
      }
    }) : (item.type === 'image') ? _c('body-image', {
      ref: _vm.setElementRef('image', index),
      refInFor: true,
      attrs: {
        "item": item,
        "type": _vm.articleType,
        "shareData": _vm.shareData(),
        "itemIndex": item.itemTypeIndex,
        "inlinePhotoList": _vm.node.inlinePhotoList
      }
    }) : (item.type === 'iframe') ? _c('body-iframe', {
      ref: _vm.setElementRef('iframe', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'twitter') ? _c('body-twitter', {
      ref: _vm.setElementRef('twitter', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'instagram') ? _c('body-instagram', {
      ref: _vm.setElementRef('instagram', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'chart') ? _c('body-chart', {
      ref: _vm.setElementRef('chart', index),
      refInFor: true,
      attrs: {
        "item": item,
        "nid": _vm.node.nid
      }
    }) : (item.type === 'blockquote') ? _c('body-blockquote', {
      ref: _vm.setElementRef('blockquote', index),
      refInFor: true,
      attrs: {
        "item": item,
        "node": _vm.node,
        "isBodyLeftQuoteMode": _vm.isBodyLeftQuoteMode
      }
    }) : (item.type === 'person') ? _c('div', {
      ref: _vm.setElementRef('person', index),
      refInFor: true,
      staticClass: "related-person-group"
    }, [_c('body-related-widget', {
      staticClass: "hidden-sm-down",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "desktop"
      }
    }), _c('body-related-widget', {
      staticClass: "hidden-sm-up",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "mobile"
      }
    })], 1) : (item.type === 'whatis' && _vm.isShowingWhatisWidget(_vm.node, item)) ? _c('div', {
      ref: _vm.setElementRef('whatis', index),
      refInFor: true,
      staticClass: "whatis-widget-group"
    }, [_c('body-related-widget', {
      staticClass: "hidden-sm-down",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "desktop"
      }
    }), _c('body-related-widget', {
      staticClass: "hidden-sm-up",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "mobile"
      }
    })], 1) : _vm._e(), _vm._l((_vm.alsoReadArticles), function(article, articleIndex) {
      return (_vm.getBodyOptions.alsoRead.enable) ? [(article.insertAtIndex === index && article.isIndexAvailable) ? _c('also-read', {
        attrs: {
          "data-index": index,
          "article": article
        }
      }) : _vm._e()] : _vm._e()
    }), (_vm.inlineNewsletterIndex && _vm.inlineNewsletterIndex === index) ? _c('div', {
      staticClass: "center-wrapper hidden-md-up"
    }, [(_vm.getBodyOptions.inlineNewsletter) ? _c('div', {
      staticClass: "newsletter-form-wrapper no-article-gutter-mobile"
    }, [_c('inline-newsletter-form', {
      attrs: {
        "newsletterType": _vm.getNewsLetterType,
        "theme": _vm.newsLetterTheme
      }
    })], 1) : _vm._e()]) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc463cd0","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/fields/Body.vue
// module id = 1105
// module chunks = 1 4 5